import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-snitem-table-control',
  templateUrl: './snitem-table-control.component.html',
  styleUrls: ['./snitem-table-control.component.scss']
})
export class SNItemTableControlComponent implements OnInit {

  @Input() service: any;

  constructor() { }

  ngOnInit(): void {
  }

}
